import * as React from "react";
import { observer } from "mobx-react-lite";
import { AColumn, AsyncTable } from "src/components/tables/AsyncTable";
import { selectOnRowClick } from "src/components/tables/selectOnRowClick";
import { ZBom2a } from "../../../../Bom2aTypes";
import { Bom2aPosCopyFromStore } from "./Bom2aPosCopyFromStore";

interface PropsBom2aPosCopyFromStep2 {
  store: Bom2aPosCopyFromStore;
}

export const Bom2aPosCopyFromStep2: React.FC<PropsBom2aPosCopyFromStep2> =
  observer(({ store }) => {
    const { bomsStore } = store;
    if (!bomsStore) return null;
    return (
      <AsyncTable
        store={bomsStore}
        columns={columns}
        onRowClick={(row) => selectOnRowClick(row, bomsStore)}
      />
    );
  });

const columns: AColumn<ZBom2a>[] = [
  {
    key: "name",
    title: "Название",
    render: (_, { name }) => name,
  },
];
